module.exports = __webpack_public_path__ + "static/img/news_15.b8216ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_15.jpg
// module id = DACA
// module chunks = 2